import { $api } from '@shared/api';
import { handleAxiosFetchErrorsSwal } from '@shared/helpers/fetchHelpers';

export const sendAdminForm = async ({ formData, id }: { id: number; formData: FormData }) => {
    // @ts-ignore
    const url = helpable.replaceUrlParameters(
        // @ts-ignore
        routable.getRoute('adminCommunicationAddRecipients'),
        {
            _itemId_: id,
        }
    );

    try {
        // @ts-ignore
        loader.show();
        const response = await $api.post(url, formData);
        // @ts-ignore
        loader.hide();
        return response.data;
    } catch (error) {
        handleAxiosFetchErrorsSwal(error?.response?.data);
        return error.message;
    }
};
